module.exports = __webpack_public_path__ + "media/icons/addperson-b123ed4f.png";